import React from 'react';

export default class  Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">This tool can help</div>
                                            <p>This study and subsequent similar studies demonstrate the impact
                                                that social influence can have on people. Despite holding
                                                independent and rational views, many people feel obliged to be
                                                obedient when instructed by an authority figure. Although this
                                                type of influence can be used in a negative way, it can also be
                                                used positively to achieve business growth. This tool is
                                                about <span
                                                    className="brown brownbold">how to influence others</span> in
                                                a genuine and positive way. It will help you to develop and
                                                utilise a range of different styles to persuade and influence
                                                your colleagues in the workplace.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">INFLUENCING PEOPLE WITHOUT MAKING ENEMIES</span>
                                            </div>
                                            <p>There are mixed feelings about the subject of influence, as well
                                                as some confusion. When we describe
                                                someone as ‘influential’ we do so in ways that suggest respect,
                                                admiration, even deference – it’s a
                                                quality to which we seem to aspire. At the same time, however,
                                                we’re disparaging or suspicious when
                                                we recognise attempts to influence us – by politicians,
                                                advertisers, friends and sometimes even family.
                                                So, is it something we’d all like to be able to do – but only if
                                                no one realises we’re doing it? </p>
                                            <p>We weren’t always so coy. There’s a whole industry of self-help
                                                books advising parents on how to
                                                withstand the ruthless influencing skills of babies and young
                                                children. You might remember some of
                                                your own tactics which you probably wish you could use in the
                                                office, right now: refusal to cooperate,
                                                blackmail, bargaining, refusing to give up or in and, when all
                                                else fails, yelling.</p>
                                            <p>So, we’re all about influencing and being influenced, it’s just
                                                that as adults we behave more artfully.
                                                We’ve finessed our earlier tactics to work better on peers and
                                                superiors using reasoned resistance,
                                                negotiation and more respectable forms of perseverance and
                                                tenacity.</p>
                                            <p>You need a strategy which will work best for you, according to
                                                your personality, but there are some
                                                essentials to remember whichever way you go about it.</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Remember the following when
                                                    trying to influence:
                                                </div>
                                                <ul className="greenbullet-list">

                                                    <li>Rapport is essential. Developing a sense of likeability
                                                        and trust with the person you’re trying to influence
                                                        will only put you in a better position. To learn how to
                                                        do this, have a read through the iLEAD™ tool ‘How to
                                                        develop rapport’.
                                                    </li>
                                                    <li>Listen to other people’s points of view and try to put
                                                        yourself in their shoes. It’s a great advantage to
                                                        understand and be able to empathise with someone else’s
                                                        situation, motives and needs if you’re going to try and
                                                        persuade them towards an alternative.
                                                    </li>
                                                    <li>Identify any common goals, for example ‘We all need to
                                                        get this task completed in 3 weeks.’ And also any common
                                                        points of view or ideas.
                                                    </li>
                                                    <li>Present your ideas as a suggestion, rather than a
                                                        proposal. This way, people are more likely to build on
                                                        your idea, or see it as being flexible, which is
                                                        positive.
                                                    </li>
                                                    <li>Make sure you have people’s full attention.</li>
                                                    <li className="textbottompadding">Emphasise why your
                                                        suggestion is important (particularly where it links to
                                                        common goals you have already identified), for example
                                                        ‘What does everyone think about splitting the team into
                                                        two task groups? I think this is important, because we
                                                        need to complete the task in just 3 weeks.'
                                                    </li>
                                                </ul>
                                            </div>


                                            <div className="left-btn"><div
                                                 onClick={this.props.handleChangePage('Page1')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                 onClick={this.props.handleChangePage('Page3')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}